import { configureStore } from "@reduxjs/toolkit"; // Importing the configureStore function from Redux Toolkit
// Importing all the slice reducers for different parts of the application state
import LayoutSlice from "./Slice/LayoutSlice";
import BookmarkHeaderSlice from "./Slice/BookmarkHeaderSlice";
import ThemeCustomizerSlice from "./Slice/ThemeCustomizerSlice";
import AuthSlice from "./Slice/AuthSlice";
import DepartmentSlice from "../features/departmentList/redux/slice/DepartmentListSlice";
import CenterListSlice from "./Slice/CenterListSlice";
import EducationSlice from "./Slice/EducationSlice";
import EmployeeProfileDetailsModalSlice from "./Slice/UserProfileDetailsModalSlice/index";
import EmployeeAssignedManagerSlice from "../features/hrZone/Users/redux/slice/AssignedManagerToEmployeeSlice";
import TeamMembersListSlice from "../features/teamMembers/teamMembersList/redux/slice/teamMembersListSlice";
import TeamMembersLeaveListSlice from "../features/teamMembers/leaveList/redux/slice/teamMembersLeaveListSlice";
import EmployeeConveyanceAddSlice from "../features/conveyance/redux/slice/addConveyanceSlice";
import TeamMembersLeaveApproveRequestSlice from "../features/teamMembers/leaveList/redux/slice/teamMembersLeaveApprovedRequestSlice";
import TeamApproveAttendance from "../features/teamMembers/attendanceList/redux/slice/teamMembersAttendanceApproveSlice";
import TeamMemberAttendanceList from "../features/teamMembers/attendanceList/redux/slice/teamMembersAttendanceListSlice";
import EmployeeDashboardDetailsSlice from "../features/dashboard/redux/slice/EmployeeDashboard";
import DocumentTypeDetailsSlice from "../features/policies/slice/documentDetailsSlice";
import UploadDailyReportUserSlice from "./Slice/UploadDailyReportSlice/index";
import GetDailyReportListSlice from "./Slice/GetDailyReportSlice/index";
import DownloadDailyReportSlice from "./Slice/DownloadDailyReportSlice/index";
import EmployeesListSlice from "../features/hrZone/Users/redux/slice/EmployeesListSlie";
import CheckUserDetailsSlice from "./Slice/CheckUserDetailsSlice/index";
import SubDepartmentListSlice from "./Slice/SubDepartmentSlice/index";

import EmployeeManagerUpdateSlice from "../features/hrZone/Users/redux/slice/EmployeeManagerUpdateSlice";
import EmployeePettyCashAccountZoneDashboardSlice from "../features/pettyCash/AccountZone/redux/slice/PettyCashAccountZoneDashboard";
import EmployeeAttachmentSlice from "./Slice/AttachmentSlice/index";
import FinancialYearSlice from "./Slice/FinancialYearSlice/index";
import EmployeeUpdateStatusSlice from "../features/hrZone/Users/redux/slice/EmployeeStatusUpdateSlice";
import EmployeeUpdateEditOptionSlice from "../features/hrZone/Users/redux/slice/EmployeeEditOptinSlice";
import TeamMembersAttendanceBulkApprove from "../features/teamMembers/attendanceList/redux/slice/teamMembersAttendanceBulkApproveSlice";
import EllipsisDropdownSlice from "./Slice/EllipsisDrodownSice.ts/index";
import EmployeeChangePasswordSlice from "./Slice/ChangePasswordSlice/index";
import EmployeesMasterReportFilterSlice from "./Slice/HRSlice/EmployeeMasterSlice/FilterSlice/index";

import EmployeesAttendanceLeaveCorrectionSlice from "../features/reports/EmployeeSalaryReport/redux/slice/AttendanceLeaveCorrectionSlice";
import EmployeeUnderProbationSlice from "../features/hrZone/EmployeeProbation/redux/slice/EmployeeProbationListSlice";
import EmployeeProbationUpdateSlice from "../features/hrZone/EmployeeProbation/redux/slice/EmployeeUpdateProbationSlice";
import TeamMembersLeaveBulkApprovedRequest from "../features/teamMembers/leaveList/redux/slice/teamMembersLeaveBulkApprovedSlice";
import EmployeeUpdateCallingSystemStatusSlice from "../features/employeesCallingSystem/redux/slice/EmployeeCallingSystemStatusSlice";
import EmployeeSurveyFormsSlice from "../features/surveyForms/FormList/redux/slice/SurveyFormSlice";
import EmployeeSurveyFormWithQuestionsSlice from "../features/surveyForms/FormQuestions/redux/slice/SurveyFormWithQuestionsSlice";
import EmployeeSurveyFormQuestionAddSlice from "../features/surveyForms/FormQuestions/redux/slice/SurveyFormQuestionAdd";
import EmployeeSurveyFormResponseSlice from "../features/surveyForms/FormResponse/redux/slice/SurveyFormResponseSlice";
import EmployeeSurveyFormResponseSubmitSlice from "./Slice/SurveyFormsSlice/SurveyFormResponseSubmit";
import EmployeeInvitedSlice from "../features/surveyForms/FormList/redux/slice/SurveyFormInvitedEmployeesSlice";
import EmployeeAssignInvitedSlice from "../features/surveyForms/FormList/redux/slice/SurveyFormAssignInvitedEmployeesSlice";
import EmployeeSurveyFormQuestionStatusUpdateSlice from "./Slice/SurveyFormsSlice/ChangeStatusSurveyQuestion"; //for form related questions status update
import EmployeeUpdateSurveyFormStatusSlice from "../features/surveyForms/FormList/redux/slice/SurveyFormStatusSlice"; // for form status update
import CreateDepartmentSlice from "../features/departmentList/redux/slice/CreateDepartmentSlice";
import EditDepartmentSlice from "../features/departmentList/redux/slice/EditDepartmentSlice";
import UpdateDepartmentSlice from "../features/departmentList/redux/slice/UpdateDepartmentSlice";
import UpdateDepartmentStatusSlice from "../features/departmentList/redux/slice/DepartmentStatusSlice";
import EmployeeDailyDairySlice from "../features/dailyDairyReport/redux/slice/dailyDairySlice";
import DepartmentCategoryListSlice from "../features/dailyTaskList/redux/slice/departmentCategorySlice";
import DepartmentCategoryOptionsSlice from "../features/dailyTaskList/redux/slice/departmentCategoryOptionsSlice";
import AddDepartmentTaskSlice from "../features/dailyTaskList/redux/slice/createDepartmentCategorySlice";
import DepartmentCategoryStateSlice from "../features/dailyTaskList/redux/slice/departmentCategoryStateSlice";
import DeleteDepartmentCategorySlice from "../features/dailyTaskList/redux/slice/deleteDepartmentCategorySlice";
import EmployeeCloseDailyDairySlice from "../features/dailyDairyReport/redux/slice/closeDailyDairySlice";
import EmployeeSubmitDailyDairySlice from "../features/dailyDairyReport/redux/slice/submitDailyDairySlice";
import EmployeeDailyDairySlotsSlice from "../features/dailyDairyReport/redux/slice/dailyDairySlotSlice";
import DepartmentSubCategoryListSlice from "../features/dailyTaskList/redux/slice/departmentSubCategorySlice";
import TeamMembersDailyDairyReportSlice from "../features/teamMembers/dailyDairyReport/redux/slice/DailyDairyReportSlice";
import EmployeeDashboardPopUpSlice from "../features/dashboard/redux/slice/EmployeeDashboardPopUpSlice";
import DesignationList from "../features/designation/redux/slice/designationListSlice";
import EditDesignationList from "../features/designation/redux/slice/editDesignationSlice";
import SaveUpdateDesignation from "../features/designation/redux/slice/saveUpdateDesignationSlice";
import SaveUpdateFormSlice from "../features/surveyForms/FormList/redux/slice/SaveUpdateSurveyFormSlice";
import FormEditSlice from "../features/surveyForms/FormList/redux/slice/EditSurveyFormSlice";
import UserTypesSlice from "../features/surveyForms/FormList/redux/slice/UserTypesSlice";
import SectionListSlice from "../features/surveyForms/FormList/redux/slice/SectionListSlice";
import SectionAddSlice from "../features/surveyForms/FormList/redux/slice/SaveSectionSlice";
import FormResponsesSlice from "../features/surveyForms/FormList/redux/slice/SurveyFormResponsesSlice";
import ProbationReminderMailerSlice from "../features/hrZone/EmployeeProbation/redux/slice/ProbationReminderMailerSlice";
import MenuSlice from "./Slice/MenuSlice";
import InventoryCategoryListSlice from "../features/inventoryManagement/category/redux/slice/inventoryCategoryListSlice";
import SaveUpdateInventoryCategorySlice from "../features/inventoryManagement/category/redux/slice/saveUpdateInventoryCategorySlice";
import EditInventoryCategorySlice from "../features/inventoryManagement/category/redux/slice/editInventoryCategorySlice";
import InventoryVendorListSlice from "../features/inventoryManagement/vendors/redux/slice/inventoryVendorListSlice";
import SaveUpdateinventoryVendorSlice from "../features/inventoryManagement/vendors/redux/slice/inventoryVendorCUDSlice";
import EditInventoryVendorSlice from "../features/inventoryManagement/vendors/redux/slice/inventoryVendorEditSlice";
import InventoryProductListSlice from "../features/inventoryManagement/products/redux/slice/inventoryProductSlice";
import SaveInventoryProductSlice from "../features/inventoryManagement/products/redux/slice/saveInventoryProduct";
import EditInventoryProductSlice from "../features/inventoryManagement/products/redux/slice/editInventoryProductSlice";
import UpdateInventoryProductSlice from "../features/inventoryManagement/products/redux/slice/updateInventoryProductSlice";
import SaveInventoryActionSlice from "../features/inventoryManagement/products/redux/slice/inventoryActionSlice";
import SelectEmployeeInventoryProductListData from "../features/inventoryManagement/InventoryAssets/redux/slice/employeeInventoryProductSlice";
import InventoryProductLogsSlice from "../features/inventoryManagement/products/redux/slice/inventoryProductLogs.slice";
import InventoryOtpModalSlice from "../features/inventoryManagement/products/redux/slice/sendInventoryActionOtpSlice";
import BrandListSlice from "../features/inventoryManagement/products/redux/slice/inventoryBrandSlice";
import EmployeeManagementSlice from "../features/employeeManagement/redux/slice/EmployeeManagementSlice";
import { setupListeners } from "@reduxjs/toolkit/query";
import { rootApi } from "./api";
import EmployeesTypesSlice from "../features/employeeManagement/redux/slice/EmployeeRoleSlice";

// Setting up the Redux store by combining all the slices into the reducer
const Store = configureStore({
  reducer: {
    menu: MenuSlice,
    layout: LayoutSlice,
    bookmarkHeader: BookmarkHeaderSlice,
    themeCustomizer: ThemeCustomizerSlice,
    authSlice: AuthSlice,
    centerList: CenterListSlice,
    departmentList: DepartmentSlice,
    educationList: EducationSlice,

    employeeDashboardDetailsSlice: EmployeeDashboardDetailsSlice,
    employeeDashboardPopUpSlice: EmployeeDashboardPopUpSlice,
    employeeChangePassword: EmployeeChangePasswordSlice,
    employeeManagement: EmployeeManagementSlice,
    employeeProfileDetailModalSlice: EmployeeProfileDetailsModalSlice,
    employeeAssignedManagerDetails: EmployeeAssignedManagerSlice,
    employeeConveyanceAdd: EmployeeConveyanceAddSlice,

    employeePettyCashAccountZoneDashboard:
      EmployeePettyCashAccountZoneDashboardSlice,
    employeeManagerUpdate: EmployeeManagerUpdateSlice,
    employeeUpdateStatus: EmployeeUpdateStatusSlice,
    employeeUpdateEditOption: EmployeeUpdateEditOptionSlice,
    employeeAttachments: EmployeeAttachmentSlice,
    employeeDailyDairySlice: EmployeeDailyDairySlice,
    employeeCloseDailyDairy: EmployeeCloseDailyDairySlice,
    employeeSubmitDailyDairy: EmployeeSubmitDailyDairySlice,
    employeeDailyDairySlots: EmployeeDailyDairySlotsSlice,
    employeeUnderProbation: EmployeeUnderProbationSlice,
    employeeProbationUpdate: EmployeeProbationUpdateSlice,
    employeeCallingSystemUpdateStatus: EmployeeUpdateCallingSystemStatusSlice,
    employeeSurveyFormInvited: EmployeeInvitedSlice,
    employeeSurveyForms: EmployeeSurveyFormsSlice,
    employeeSurveyFormWithQuestions: EmployeeSurveyFormWithQuestionsSlice,
    employeeSurveyFormQuestionAdd: EmployeeSurveyFormQuestionAddSlice,
    employeeSurveyFormResponse: EmployeeSurveyFormResponseSlice,
    employeeSurveyFormResponseSubmit: EmployeeSurveyFormResponseSubmitSlice,
    employeeSurveyFormAssignInvited: EmployeeAssignInvitedSlice,
    employeeSurveyFormQuestionStatusUpdate:
      EmployeeSurveyFormQuestionStatusUpdateSlice,
    employeeUpdateSurveyFormStatus: EmployeeUpdateSurveyFormStatusSlice,
    employeesList: EmployeesListSlice,

    teamMembers: TeamMembersListSlice,
    teamMembersLeaveList: TeamMembersLeaveListSlice,
    teamMembersLeaveApproved: TeamMembersLeaveApproveRequestSlice,
    teamMembersLeaveBulkApprovedRequest: TeamMembersLeaveBulkApprovedRequest,
    teamMembersAttendanceList: TeamMemberAttendanceList,
    teamMembersAttendanceApprove: TeamApproveAttendance,
    teamMembersAttendanceBulkApprove: TeamMembersAttendanceBulkApprove,
    teamMembersDailyDairyReport: TeamMembersDailyDairyReportSlice,

    documentTypeDetails: DocumentTypeDetailsSlice,
    uploadDailyReportUserSlice: UploadDailyReportUserSlice,
    dailyReportUserListSlice: GetDailyReportListSlice,
    downloadDailyReportSlice: DownloadDailyReportSlice,
    checkUserDetailsSlice: CheckUserDetailsSlice,
    subDepartmentListDetailsSlice: SubDepartmentListSlice,
    financialYearSlice: FinancialYearSlice,
    ellipsisDropdownSlice: EllipsisDropdownSlice,

    employeesMasterReportFilter: EmployeesMasterReportFilterSlice,
    employeesAttendanceLeaveCorrection: EmployeesAttendanceLeaveCorrectionSlice,

    createDepartment: CreateDepartmentSlice,
    editDepartment: EditDepartmentSlice,
    updateDepartment: UpdateDepartmentSlice,
    updateDepartmentStatus: UpdateDepartmentStatusSlice,
    departmentCategoryList: DepartmentCategoryListSlice,
    departmentSubCategoryList: DepartmentSubCategoryListSlice,
    createDepartmentCategory: AddDepartmentTaskSlice,
    deleteDepartmentCategory: DeleteDepartmentCategorySlice,
    departmentCategoryState: DepartmentCategoryStateSlice,
    departmentWiseCategoryOptions: DepartmentCategoryOptionsSlice,
    designationList: DesignationList,
    designationEdit: EditDesignationList,
    saveUpdateDesignation: SaveUpdateDesignation,
    saveUpdateFormSlice: SaveUpdateFormSlice,
    formEditSlice: FormEditSlice,
    userTypesSlice: UserTypesSlice,
    sectionListSlice: SectionListSlice,
    sectionAddSlice: SectionAddSlice,
    formResponsesSlice: FormResponsesSlice,
    probationReminderMailerSlice: ProbationReminderMailerSlice,
    employeesTypeSlice: EmployeesTypesSlice,
    inventoryCategoryListSlice: InventoryCategoryListSlice,
    saveUpdateInventoryCategorySlice: SaveUpdateInventoryCategorySlice,
    editInventoryCategorySlice: EditInventoryCategorySlice,
    inventoryVendorListSlice: InventoryVendorListSlice,
    saveUpdateinventoryVendorSlice: SaveUpdateinventoryVendorSlice,
    editInventoryVendorSlice: EditInventoryVendorSlice,
    inventoryProductListSlice: InventoryProductListSlice,
    saveInventoryProductSlice: SaveInventoryProductSlice,
    editInventoryProductSlice: EditInventoryProductSlice,
    updateInventoryProductSlice: UpdateInventoryProductSlice,
    saveInventoryActionSlice: SaveInventoryActionSlice,
    selectEmployeeInventoryProductListData: SelectEmployeeInventoryProductListData,
    inventoryProductLogsSlice: InventoryProductLogsSlice,
    inventoryOtpModalSlice: InventoryOtpModalSlice,
    brandListSlice: BrandListSlice,
    [rootApi.reducerPath]: rootApi.reducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware().concat(rootApi.middleware),
});

setupListeners(Store.dispatch);
// Exporting the store for use in the app
export default Store;

// Defining RootState and AppDispatch types for use in typed selectors and dispatching actions
export type RootState = ReturnType<typeof Store.getState>;
export type AppDispatch = typeof Store.dispatch;
